import { capitalizeFirstLetter, formatStringWithUnderscore } from '../../../../helpers/common'

import { COUNTRY } from '../../../Facebook/LineItemForms/LineItemFacebookEdit/fields'

export const formatGeolocations = (geolocations = []) => {
  return geolocations.map(({ key, name, region, type, region_id, country_code }) => {
    // include region name if it exists in data
    const itemRegion = region ? `, ${region}` : ''
    const countryCode = type === COUNTRY ? ` (${country_code})` : ''
    return {
      value: key,
      label: name + itemRegion + countryCode,
      type,
      region_id,
      description: capitalizeFirstLetter(formatStringWithUnderscore(type))
    }
  })
}
